<template>
  <div>
    <div class="profile-name">
      <div class="wrapper">
        <h2>Hi, {{ name }}, Let's Get Started</h2>
        <p>
          Enter your BLOGGER profile name. This will be permanent, so please
          choose your name wisely.
        </p>
        <span class="at">@</span>
        <input
          type="text"
          v-model="profileName"
          @input="removeSpaces"
          placeholder="Enter your profile name"
        />
        <div v-if="error" class="error">
          {{ error }}
        </div>
        <b-button
          :disabled="!isNameValid()"
          variant="primary"
          @click="updatePofileName"
        >
          <b-spinner
            class="spinner"
            v-if="processing"
            variant="primary"
            label="Loading..."
          ></b-spinner>
          <span v-else>
            Apply
          </span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blogger-profile-name",
  data() {
    return {
      profileName: "",
      error: "",
      processing: false
    };
  },
  props: {
    name: {
      type: String,
      default: "D3rriana User"
    }
  },
  methods: {
    updatePofileName() {
      this.error = "";
      this.processing = true;
      this.$store
        .dispatch("listings/checkBloggerProfileName", this.profileName)
        .then(res => {
          console.log(res);
          if (res == "accepted") {
            this.$store
              .dispatch("user/saveBloggerProfileName", this.profileName)
              .then(res => {
                this.$store.dispatch("user/getProfile").then(profile => {
                  this.$store
                    .dispatch("listings/activateBlogger", profile)
                    .then(() => {
                      this.processing = false;
                      this.$emit("completed");
                    });
                });
              })
              .catch(e => {
                console.log("Error while saving Profile Name:", e);
                this.processing = false;
              });
          } else if (res == "already taken") {
            this.processing = false;
            this.error = `Profile Name ${this.profileName} is already taken.`;
          }
        })
        .catch(e => {
          console.log("Error while checking Existing Profile Names:", e);
          this.processing = false;
        });
    },
    isNameValid() {
      if (this.profileName == "") {
        return false;
      } else if (this.profileName.length > 4) {
        return true;
      }
    },
    removeSpaces() {
      this.profileName = this.profileName.trim();
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-name {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 72px;
  .wrapper {
    width: 380px;
    .btn-primary {
      border-radius: 20px !important;
      width: 100%;
      font-weight: bold !important;
    }
    .spinner {
      width: 1.7rem;
      height: 1.7rem;
    }
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 33px;
      margin-bottom: 20px;
      text-align: center;
      color: #474d52;
    }
    p {
      text-align: center;
      margin-bottom: 25px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      text-align: center;

      color: #474d52;
    }
    .at {
      margin-top: 10px;
      margin-left: 15px;
      position: absolute;
    }
    input {
      margin-bottom: 25px;
      background: #ffffff;
      height: 47px; /* text-field */
      width: 100%;
      font-size: 16px;
      line-height: 22px;
      padding: 10px 24px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 40px;
      border: none;
      padding-left: 35px;
    }
  }
}
</style>
